import ClickAwayListener from '@mui/material/ClickAwayListener';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useTheme } from '@mui/material';
// import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
// import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';
import LogoutIcon from '@mui/icons-material/Logout';
// import AddIcon from '@mui/icons-material/Add';
import { useAuth } from 'src/contexts/AuthContext';
// import { GradientCircularProgress } from '../gradients/GradientCircularProgress';
// import { useState } from 'react';
// import { truncate } from 'src/util/truncate';
// import { CryptoChain } from 'src/util/CryptoChain';
// import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { Link } from '../Link';
// import { AuthenticationWalletPickingPage } from '../authentication/flow-pages/wallet-pages/AuthenticationWalletPickingPage';
// import Dialog from '@mui/material/Dialog';
// import DialogContent from '@mui/material/DialogContent';
// import { useTheme } from '@mui/material/styles';
// import RefreshIcon from '@mui/icons-material/Refresh';

const sx = {
  box: {
    display: 'flex',
    alignItems: 'center',
  },
};
// type MenuItemAddProps = {
//   content: string;
//   close: () => void;
//   handleClick: (() => Promise<void>) | (() => void);
// };

// const MenuItemAdd = ({
//   content,
//   close,
//   handleClick = () => {
//     close();
//   },
// }: MenuItemAddProps) => {
//   const [executing, setExecuting] = useState(false);
//   return (
//     <MenuItem
//       onClick={async () => {
//         setExecuting(true);
//         await handleClick();
//         setExecuting(false);
//       }}
//     >
//       <Box sx={sx.box}>
//         {!executing ? (
//           <AddIcon width={24} height={24} sx={{ mr: 1 }} />
//         ) : (
//           <LottieLoader sx={{ height: '24px', width: '24px' }} />
//         )}
//         <Box sx={{ ml: executing ? 1.5 : 0 }}>{content}</Box>
//       </Box>
//     </MenuItem>
//   );
// };

//commented out until we know the details of the implementation

// const MenuItemRecent = ({ content, close }) => {
//   const handleClick = () => {
//     close();
//   };
//   return (
//     <MenuItem onClick={handleClick}>
//       <Box sx={sx.box}>
//         <RefreshIcon width={24} height={24} sx={{ mr: 1 }} />
//         {content}
//       </Box>
//     </MenuItem>
//   );
// };

// const MenuItemWallet = ({ providerName, authMethods }) => {
//   return (
//     <MenuItem>
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         <Box sx={sx.box}>
//           <Image
//             width={24}
//             height={24}
//             src={`/assets/images/wallets/${providerName}.png`}
//             alt={''}
//           />
//           <Box sx={{ ml: 2 }}>{truncate(authMethods[0].address)}</Box>
//         </Box>
//         <Box sx={sx.box}>
//           <SubdirectoryArrowRightIcon sx={{ width: 24, height: 24, mr: 2 }} />
//           {authMethods.map((method) => {
//             return (
//               <Box
//                 key={method.chainId}
//                 sx={{ mr: 1, display: 'flex', alignItems: 'center' }}
//               >
//                 <Image
//                   width={24}
//                   height={24}
//                   src={`/assets/images/chains/${
//                     CryptoChain.from(method.chainId).name
//                   }.png`}
//                   alt={''}
//                 />
//               </Box>
//             );
//           })}
//         </Box>
//       </Box>
//     </MenuItem>
//   );
// };

// const MenuItemLink = ({ content, close, linked }) => {
//   const handleClick = () => {
//     close();
//   };
//   return (
//     <MenuItem onClick={handleClick}>
//       <Box sx={sx.box}>
//         {linked ? (
//           <LinkOffRoundedIcon width={24} height={24} sx={{ mr: 1 }} />
//         ) : (
//           <LinkRoundedIcon width={24} height={24} sx={{ mr: 1 }} />
//         )}
//         {content}
//       </Box>
//     </MenuItem>
//   );
// };

type SignInMenuProps = {
  open: boolean;
  anchorEl: Element;
  handleMenuClose: () => void;
  logout: () => void;
};

export function SignInMenu({
  open,
  anchorEl,
  handleMenuClose,
  logout,
}: SignInMenuProps) {
  //const theme = useTheme();
  const { user } = useAuth();
  const theme = useTheme();
  // const [isWalletPickingOpen, setIsWalletPickingOpen] = useState(false);
  // const handleAddWallet = async () => {
  //   setIsWalletPickingOpen(true);
  // };
  // const groupProviders = () => {
  //   const wallets = userData?.hidden?.auth?.filter(
  //     (obj) => obj.method === 'wallet',
  //   );
  //   if (!wallets) {
  //     return {};
  //   }
  //   const providers = wallets.map((authMethod) => {
  //     return authMethod.provider;
  //   });
  //   if (!providers) {
  //     return {};
  //   }

  //   const methodsByProvider = {};
  //   providers.forEach((provider) => {
  //     methodsByProvider[`${provider}`] = wallets.filter(
  //       (wallet) => wallet.provider === provider,
  //     );
  //   });
  //   return methodsByProvider;
  // };
  // const signInOptions: { name: string; url: string; linked: boolean }[] = [
  // TODO {
  //   name: 'Twitter sign-in',
  //   url: null,
  //   linked: true,
  // },
  // {
  //   name: 'Google sign-in',
  //   url: null,
  //   linked: false,
  // },
  // {
  //   name: 'Telegram sign-in',
  //   url: null,
  //   linked: true,
  // },
  // {
  //   name: 'Facebook sign-in',
  //   url: null,
  //   linked: false,
  // },
  // {
  //   name: 'Email & Password',
  //   url: null,
  //   linked: false,
  // },
  // {
  //   name: 'Phone sign-in',
  //   url: null,
  //   linked: true,
  // },
  // ];
  const handleLogout = () => {
    logout();
    handleMenuClose();
  };
  return (
    <>
      <ClickAwayListener onClickAway={handleMenuClose}>
        <Menu
          open={open}
          anchorEl={anchorEl}
          elevation={8}
          hideBackdrop={true}
          sx={{
            zIndex: theme.zIndex.appBar - 1,
            width: '175px',
            height: '130px',
          }}
        >
          <Link
            href={`/profile/${user?.uid}`}
            sx={{ textDecoration: 'none' }}
            onClick={handleMenuClose}
          >
            <MenuItem sx={{ pt: 3 }}>View Profile</MenuItem>
          </Link>
          {/* {Object.entries(groupProviders()).map(
            ([providerName, authMethods]) => {
              return (
                <MenuItemWallet
                  key={providerName}
                  providerName={providerName}
                  authMethods={authMethods}
                />
              );
            },
          )} */}
          {/* TODO: reintroduce 
          <MenuItemAdd
            handleClick={handleAddWallet}
            close={handleMenuClose}
            content={'wallet address'}
          /> */}
          {/* {signInOptions.map((option, idx) => {
            return (
              <MenuItemLink
                close={handleMenuClose}
                key={idx}
                content={option.name}
                linked={option.linked}
              />
            );
          })} */}
          <MenuItem onClick={handleLogout}>
            <Box sx={sx.box}>
              <LogoutIcon sx={{ mr: 1 }} />
              Sign Out
            </Box>
          </MenuItem>
        </Menu>
      </ClickAwayListener>
      {/* <Dialog
        open={isWalletPickingOpen}
        color="secondary"
        sx={{
          backdropFilter: theme.glass[8],
          '& .MuiPaper-root': {
            borderRadius: '10px',
          },
        }}
      >
        <Box
          sx={{
            boxShadow:
              '0.5px 2px 25px 3px rgba(0, 51, 233, 0.15), 0px 1px 15px 1px rgba(0, 51, 233, 0.3)',
            border: 'double 2px transparent',
            borderRadius: '10px',
            backgroundImage: `linear-gradient(${theme.palette.background.elevation[8]}, 
          ${theme.palette.background.elevation[8]}), linear-gradient(180deg, #4DC8FF 0%, #0064E9 100%)`,
            backgroundOrigin: 'border-box',
            backgroundClip: 'content-box, border-box',
          }}
        >
          <AuthenticationWalletPickingPage
            pageId={'pick wallet'}
            onPageComplete={() => setIsWalletPickingOpen(false)}
          />
        </Box>
      </Dialog> */}
    </>
  );
}
